import Vue from 'vue'
import App from './App'
import router from './router'

import 'classlist-polyfill'
import 'common/scss/common.scss'
import 'common/api/promise'
import 'common/api/api'
import common from 'common/api/yfdCommon'
import VueProgressiveImage from 'vue-progressive-image'
import VueScrollReveal from "vue-scroll-reveal";


Vue.use(VueProgressiveImage);
Vue.use(VueScrollReveal);

Vue.config.productionTip = false;
Object.assign(Vue.prototype, common);

router.afterEach(() => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js